import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Grid, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useMemo, useRef, useState } from 'react';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import Loader3D from '../../../../components/Loader/Loader3D';
import { getOgdTeamColorById } from '../../../../utils/constants/functions';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getProjectWise } from '../../../../redux/features/poinTrackerSlice';
import { ogdWings } from '../../../../utils/constants/GlobalStaticData';
import { getWingsUnderDeptId } from '../../../../redux/features/generalSlice';
import { ogdDepartmentId } from '../../../../utils/constants/departmentDetails';

const tableHeaders = [
  { id: 'projectName', label: 'Project Name' },
  { id: 'noOfLeads', label: 'No of Leads' },
  { id: 'assessments', label: 'Assessments' },
  { id: 'sales', label: 'Sales' },
  { id: 'revenue', label: 'Revenue' },
  { id: 'arpu', label: 'ARPU' },
  { id: 'lcr', label: 'LCR' },
  { id: 'acr', label: 'ACR' },
  { id: 'ltac', label: 'LTA' },
];

const ProjectWise = ({ fromDate, toDate, setFromDate, setToDate, selectedTeam, setSelectedTeam }) => {
  const projectWise = useSelector((state) => state.pointTracker.projectWise);
  const wingsUnderDeptId = useSelector((state) => state.general.wingsUnderDeptId);
  const { data: wingsData } = wingsUnderDeptId;
  const teams = wingsData?.map((wing) => ({ id: wing.wing_id, value: wing.wing_name })) || ogdWings;
  const { responseData, loading } = projectWise;
  const noDatafound = responseData?.data?.length === 0;
  const data = responseData?.data || [];

  const dispatch = useDispatch();
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
    };
  }, [fromDate, toDate, selectedTeam.id]);

  const previousDispatchParams = useRef(dispatchParams);

  const isApiNeeded = JSON.stringify(previousDispatchParams.current) !== JSON.stringify(dispatchParams);
  // console.log('isApiNeeded', isApiNeeded);
  // console.log(JSON.stringify(previousDispatchParams.current), JSON.stringify(dispatchParams));

  useEffect(() => {
    if (Object.entries(projectWise?.responseData || {}).length === 0 || isApiNeeded) {
      dispatch(getProjectWise(dispatchParams));
      previousDispatchParams.current = dispatchParams;
    }
  }, [dispatchParams, dispatch, projectWise?.responseData]);

  useEffect(() => {
    if (wingsData?.length === 0) {
      dispatch(getWingsUnderDeptId(ogdDepartmentId));
    }
  }, [wingsData]);

  return (
    <Paper
      sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
      }}
    >
      <Box
        sx={{
          //   background: 'linear-gradient(90deg, #2563eb, #7c3aed)',
          //   color: '#fff',
          p: { xs: 1, md: 1.5 },
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'normal', md: 'center' },
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1, md: 0 },
        }}
      >
        <Stack direction={'row'} spacing={1} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: '10px',
              background: 'rgba(255,255,255,0.2)',
            }}
          >
            <Icon
              icon="mdi:trophy-outline"
              width={30}
              style={{ backgroundColor: '#00b5d8', borderRadius: '10px', padding: '5px', color: 'white' }}
            />
          </Box>

          <Box>
            <Typography fontWeight={600}>Project Wise</Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Project wise performance
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ backgroundColor: 'white', borderRadius: '10px', p: { xs: 0, md: 1.5 } }}>
          <Grid container spacing={{ xs: 1, md: 2 }}>
            <Grid item xs={4}>
              <DatePickerCustom
                label={'From Date'}
                value={dayjs(fromDate)}
                setValue={(date) => setFromDate(date.format('YYYY-MM-DD'))}
                viewDetails={['year', 'month', 'day']}
                fullWidth
                disabled={false}
                height={36}
                fontSize={'0.75rem'}
              />
            </Grid>
            <Grid item xs={4}>
              <DatePickerCustom
                label={'To Date'}
                value={dayjs(toDate)}
                setValue={(date) => setToDate(date.format('YYYY-MM-DD'))}
                viewDetails={['year', 'month', 'day']}
                fullWidth
                disabled={false}
                height={36}
                fontSize={'0.75rem'}
              />
            </Grid>
            <Grid item xs={4}>
              <Box>
                <GlobalSelectFieldWithoutFormikNew
                  sx={{
                    minWidth: '100px',
                    '& .MuiInputBase-root': {
                      height: 36, // Reduce input height
                      fontSize: '0.75rem', // Reduce text size inside select box
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '0.75rem',
                    },
                    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                      marginTop: '3px',
                    },
                  }}
                  keys={{ itemId: 'id', itemValue: 'value' }}
                  data={[{ id: -1, value: 'All' }, ...teams]}
                  label={'Team'}
                  fullWidth={true}
                  selectedDetails={selectedTeam}
                  setChange={setSelectedTeam}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', height: '40vh' }}>
          <Loader3D />
        </Box>
      ) : noDatafound ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', height: '40vh' }}>
          <NoDataFound />
        </Box>
      ) : (
        <Box sx={{ overflowX: 'auto' }}>
          <Box sx={{ background: '#fff', minWidth: '900px' }}>
            <Table
              size="small"
              sx={{
                tableLayout: 'fixed',
                width: '100%',
                '& th, & td': { border: '1px solid #e5e7eb' },
              }}
            >
              {/* HEADER */}
              <TableHead sx={{ backgroundColor: '#00b5d8' }}>
                <TableRow>
                  {tableHeaders.map((header) => (
                    <TableCell
                      key={header.id}
                      sx={{ fontWeight: 700, width: '150px !important', color: 'white !important' }}
                    >
                      {header.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {/* BODY */}
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={row.id} sx={{ height: 50, backgroundColor: getOgdTeamColorById(row.id).bgColor }}>
                    {tableHeaders.map((header) => (
                      <TableCell
                        key={header.id}
                        sx={{ fontWeight: 500, backgroundColor: index % 2 == 0 ? '#fff' : '#ccf5fdff' }}
                      >
                        {['arpu', 'lcr', 'acr', 'ltac'].includes(header.id) ? `${row[header.id]}%` : row[header.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default ProjectWise;
